import { Card, Container, Table, TableBody, TableContainer } from '@mui/material';
import AppLoadingAndErrorWrapper from 'src/components/common/AppLoadingAndErrorWrapper';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import FormProvider from 'src/components/hook-form/form-provider';
import Scrollbar from 'src/components/scrollbar';
import { TableHeadCustom, TablePaginationCustom, TableSkeleton } from 'src/components/table';
import AppTableToolbar from 'src/components/table/AppTableToolbar';
import AppPermissions from 'src/constants/app-permissions';
import { REFERENCE_BOOK_TABLE_HEAD } from 'src/constants/tables-heads';
import { paths } from 'src/routes/paths';
import ReferenceBooksRow from './ReferenceBooksRow';
import useRefBooks from './use-ref-books';
import { Helmet } from 'react-helmet-async';

const ReferenceBooks = () => {
  const {
    isDeleting,
    setQuery,
    t,
    methods,
    handleSearch,
    isLoading,
    table,
    data,
    handleDeleteBook,
    query,
  } = useRefBooks();

  return (
    <Container>
      <Helmet>
        <title>{t('sidebar.mutoon.books')}</title>
      </Helmet>
      <AppLoadingAndErrorWrapper isLoading={isDeleting} errorMessage={null}>
        <CustomBreadcrumbs
          links={[
            {
              name: t('breadcrumbs.mutoon'),
            },
            {
              name: t('breadcrumbs.books'),
              href: paths.dashboard.contentManagement.mutoon.books,
            },
          ]}
        />
        <Card>
          <FormProvider methods={methods}>
            <AppTableToolbar
              handleSearch={handleSearch}
              setQuery={setQuery}
              search={query.search!}
              tableName=""
              buttons={[
                {
                  path: 'new',
                  permissionName: AppPermissions.BOOKS_CREATE,
                },
              ]}
            />
            <TableContainer>
              <Scrollbar>
                <Table>
                  <TableHeadCustom
                    setQuery={setQuery}
                    headLabel={REFERENCE_BOOK_TABLE_HEAD(t)}
                    methods={methods}
                  />
                  <TableBody>
                    {isLoading || isDeleting ? (
                      [...Array(table.rowsPerPage)].map((i, index) => (
                        <TableSkeleton key={index} sx={{ height: 80 }} />
                      ))
                    ) : (
                      <>
                        {data?.reference_books?.map((row) => (
                          <ReferenceBooksRow
                            key={row.bookId}
                            row={row}
                            deleteHandler={handleDeleteBook}
                          />
                        ))}
                      </>
                    )}
                  </TableBody>
                </Table>
              </Scrollbar>
            </TableContainer>
            {data && (
              <TablePaginationCustom
                count={+data.reference_books_aggregate.aggregate?.count!}
                page={+table.page}
                rowsPerPage={table.rowsPerPage}
                onPageChange={table.onChangePage}
                onRowsPerPageChange={table.onChangeRowsPerPage}
              />
            )}
          </FormProvider>
        </Card>
      </AppLoadingAndErrorWrapper>
    </Container>
  );
};

export default ReferenceBooks;
